export const ONE_SECOND_MS = 1000;
export const ONE_MINUTE_S = 60;
export const ONE_MINUTE_MS = ONE_MINUTE_S * ONE_SECOND_MS;
export const ONE_HOUR_S = ONE_MINUTE_S * 60;
export const ONE_HOUR_MS = ONE_HOUR_S * ONE_SECOND_MS;
export const ONE_DAY_S = ONE_HOUR_S * 24;
export const ONE_DAY_MS = ONE_DAY_S * ONE_SECOND_MS;
export const ONE_YEAR_S = ONE_DAY_S * 365; // seconds: 60s * 60m = 3600s/hour * 24 = s/day * 365 = s/year
export const ONE_YEAR_MS = ONE_YEAR_S * ONE_SECOND_MS;

export const TRADE_CONFIRMATION_TIMEOUT = 30_000;
